module.exports = __webpack_public_path__ + "static/media/logo_large.0232ea35.png";